import React from 'react'

const Dashboard = () => {
    return (
        <div>
            <h1>

                this is dashboard
            </h1>
        </div>
    )
}

export default Dashboard
